import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { AppConstants } from '../../../AppConstants';
import './Map.css'

const customIcon = new L.Icon({
    iconUrl: AppConstants.Images.LocationIcon,
    iconSize: [25, 35],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
});

const Map = () => {
    const { Coordinates, MapZoom, CompanyName, City } = AppConstants.Location;
    
    return (
        <div className="map-wrapper">
            <MapContainer center={Coordinates} zoom={MapZoom} scrollWheelZoom={false} attributionControl={false}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={Coordinates} icon={customIcon}>
                    <Popup>
                    {CompanyName}<br />{City}.
                    </Popup>
                </Marker>
            </MapContainer>
        </div>
    )
}
export default Map